function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", {
  type: "text/css"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M224.96 327.104h108.8c17.056 0 30.816-13.76 30.816-30.816V234.656a30.784 30.784 0 0 0-30.816-30.816h-108.8a30.752 30.752 0 0 0-30.784 30.816v61.632a30.72 30.72 0 0 0 30.784 30.816z m78.016-85.728a24.096 24.096 0 0 1 0 48.16 24.064 24.064 0 1 1 0-48.16z m168.48 147.36H224.96a30.752 30.752 0 0 0-30.784 30.816v61.632A30.752 30.752 0 0 0 224.96 512h246.528a30.784 30.784 0 0 0 30.816-30.816v-61.632a30.816 30.816 0 0 0-30.848-30.816z m-30.784 85.728a24.096 24.096 0 1 1 0.032-48.16 24.096 24.096 0 0 1-0.032 48.16z m-246.528 129.952v61.664c0 17.024 13.76 30.848 30.784 30.848h174.496c0.096-1.344 0.288-2.752 0.384-4.192v-0.16l0.864-7.584 0.096-0.992c0.352-2.496 0.672-4.896 1.152-7.392 0-0.096 0-0.192 0.096-0.384 0.672-3.84 1.344-7.808 2.208-11.648 0.096-0.416 0.16-0.672 0.16-1.024 0.48-2.368 0.992-4.672 1.568-6.976 0.096-0.192 0.096-0.48 0.192-0.704 0.864-3.68 1.92-7.424 2.976-11.232l0.288-1.152c0.672-2.112 1.248-4.352 1.92-6.432l0.288-0.992a309.44 309.44 0 0 1 3.744-10.848c0.192-0.384 0.32-0.768 0.48-1.184l2.304-6.08c0.192-0.384 0.32-0.768 0.512-1.088 1.44-3.552 2.88-7.072 4.544-10.496l0.576-1.28c0.864-1.92 1.728-3.84 2.688-5.664l0.544-1.28c1.632-3.36 3.36-6.752 5.216-10.08l0.672-1.248c0.96-1.856 2.016-3.616 3.072-5.376l0.768-1.408c1.248-2.144 2.592-4.288 3.936-6.528H224.96a30.976 30.976 0 0 0-30.816 30.912z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M480.928 922.368a279.424 279.424 0 0 1-33.728-40.608H131.584V142.24h370.688v215.68h214.752v85.152a276.096 276.096 0 0 1 61.6 15.104V286.368l-188.128-205.792H69.952v862.816h434.464c-8.192-6.56-16-13.44-23.488-21.024z m83.008-779.456l140.288 153.376h-140.288V142.912z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M905.984 681.312l-183.872-128.224h-51.2v102.4h-204.768v102.432h204.768v102.464h51.2l183.936-128.288c20.864-13.056 20.864-37.728-0.064-50.784z"
});

var SvgExtract = function SvgExtract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    t: 1588732494064,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 1650,
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExtract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/extract.edaa8ca9.svg";
export { ForwardRef as ReactComponent };